/*
 * GET RECEIPTS
*/
export const GET_RECEIPTS = "GET_RECEIPTS"
export const GET_RECEIPTS_SUCCESS = "GET_RECEIPTS_SUCCESS"
export const GET_RECEIPTS_ERROR = "GET_RECEIPTS_ERROR"

/*
 * RECEIPT Create
*/
export const CREATE_RECEIPT = "CREATE_RECEIPT"
export const CREATE_RECEIPT_SUCCESS = "CREATE_RECEIPT_SUCCESS"
export const CREATE_RECEIPT_ERROR = "CREATE_RECEIPT_ERROR"


/*
 * RECEIPTS Export
*/
export const EXPORT_RECEIPTS = "EXPORT_RECEIPTS"
export const EXPORT_RECEIPTS_SUCCESS = "EXPORT_RECEIPTS_SUCCESS"
export const EXPORT_RECEIPTS_ERROR = "EXPORT_RECEIPTS_ERROR"

export const GET_RECEIPT_TYPES = "GET_RECEIPT_TYPES"
export const GET_RECEIPT_TYPES_SUCCESS = "GET_RECEIPT_TYPES_SUCCESS"
export const GET_RECEIPT_TYPES_ERROR = "GET_RECEIPT_TYPES_ERROR"

export const CREATE_RECEIPT_TYPES = "CREATE_RECEIPT_TYPES"
export const CREATE_RECEIPT_TYPES_SUCCESS = "CREATE_RECEIPT_TYPES_SUCCESS"
export const CREATE_RECEIPT_TYPES_ERROR = "CREATE_RECEIPT_TYPES_ERROR"
